// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".TextEllipse_ul_6s-z1{padding:0;margin:0;list-style-position:inside}.TextEllipse_li_1DaDA+.TextEllipse_li_1DaDA{margin-top:4px}\n", "",{"version":3,"sources":["webpack-internal:///./node_modules/@foxford/ui/es/components/Text/TextEllipse/TextEllipse.sass"],"names":[],"mappings":"AAAA,sBACE,SAAU,CACV,QAAS,CACT,0BAA2B,CAAG,4CAG9B,cAAe","file":"TextEllipse.sass","sourcesContent":[".ul {\n  padding: 0;\n  margin: 0;\n  list-style-position: inside; }\n\n.li + .li {\n  margin-top: 4px; }\n"]}]);
// Exports
exports.locals = {
	"ul": "TextEllipse_ul_6s-z1",
	"li": "TextEllipse_li_1DaDA"
};
module.exports = exports;
